<template>
  <div class="modal fade" tabindex="-1" :id="modalId">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header py-3">
          <h5 class="modal-title">{{ $t('shop.invoice') }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" @click="close"></button>
        </div>
        <div class="modal-body p-0" style="height:80vh">
          <div v-if="isLoading" class="d-flex align-items-center justify-content-center h-100">
            <div class="spinner-border text-primary" role="status"></div>
          </div>
          <iframe v-else-if="pdfUrl" :src="pdfUrl" class="w-100 h-100 border-0"></iframe>
        </div>
        <div class="modal-footer py-2">
          <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" @click="close">{{ $t('button.close') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// Modale facture réutilisable : encapsule à la fois l'affichage (iframe +
// spinner) et la récupération du PDF (useInvoicePdf), pour éviter de
// dupliquer ce markup/cette logique dans chaque écran qui a besoin d'afficher
// une facture de commande (Contact/View.vue, Shop/Order.vue...).
import { useInvoicePdf } from "@/composables/useInvoicePdf";

const props = defineProps({
  // Un id distinct par instance : plusieurs pages peuvent avoir leur propre
  // modale facture montée en même temps (ex: fiche client + un autre onglet).
  modalId: { type: String, default: 'invoicePdfModal' },
});

const { pdfUrl, isLoading, openInvoicePdf, closeInvoicePdf } = useInvoicePdf();

async function open(checkoutId) {
  $('#' + props.modalId).modal('show');
  try {
    await openInvoicePdf(checkoutId);
  } catch (e) {
    $('#' + props.modalId).modal('hide');
  }
}

function close() {
  closeInvoicePdf();
}

defineExpose({ open, close });
</script>
